<h2 mat-dialog-title>Logged Out</h2>
<mat-dialog-content>
  <p>You have been logged out because you logged out in another tab.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" cdkFocusInitial (click)="onConfirm()">OK</button>
</mat-dialog-actions>